module.exports = __webpack_public_path__ + "img/u654.8e271ab3.svg";